import { Component, OnInit } from '@angular/core';
import { SignalRService } from '../signal-r.service';

@Component({
  selector: 'app-application-alerts',
  templateUrl: './application-alerts.component.html',
  styleUrls: ['./application-alerts.component.scss']
})
export class ApplicationAlertsComponent implements OnInit {
  /** Holds alerts */
  alerts: any[] = [];
  constructor(private signalRSvc: SignalRService) { }
  ngOnInit() {
    this.signalRSvc.initializeAlertsSignalRConnection();
    this.signalRSvc.alerts.subscribe((res) => {
      if (res) {
        this.alerts = res;
      }
    });
    window.onbeforeunload = () => this.ngOnDestroy();
  }
  ngOnDestroy(): void {
  }
}
